import React from 'react';
import { Maximize2 } from 'lucide-react';
import { useChatbot } from '../../contexts/ChatbotContext';
import PropertySearchChat from './PropertySearchChat';
import { cn } from '../../lib/utils';
import avatarImage from '../../assets/img3d/Avatar.png';

/**
 * ChatbotInline Component
 * Inline variant of the chatbot for hero section integration
 * - No backdrop
 * - No fixed positioning
 * - Always visible (no close button)
 * - Glassmorphism design
 */
const ChatbotInline = () => {
  const { roleConfig, openChatbot } = useChatbot();

  return (
    <div
      className={cn(
        'w-full h-[520px] max-w-lg',
        'flex flex-col overflow-hidden',
        // Glassmorphism style
        'bg-white/90 backdrop-blur-xl',
        'rounded-3xl',
        'shadow-2xl border border-white/40',
        'animate-in fade-in zoom-in-95 duration-500'
      )}
    >
      {/* Header */}
      <div
        className={cn(
          'px-5 py-4 flex items-center gap-3',
          'bg-gradient-to-r from-orange-200/60 via-orange-100/40 to-white',
          'text-slate-700',
          'border-b border-white/30'
        )}
      >
        <div className="w-11 h-11 rounded-xl overflow-hidden flex items-center justify-center bg-orange-100 flex-shrink-0">
          <img 
            src={avatarImage} 
            alt="Assistant Cynthia" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-base text-slate-800 truncate">
            Cynthia
          </h3>
          <p className="text-xs text-slate-600 truncate">
            Recherche conversationnelle
          </p>
        </div>
        <button
          onClick={() => openChatbot('search')}
          className={cn(
            'p-2 rounded-lg',
            'text-slate-600 hover:text-slate-800',
            'hover:bg-white/50',
            'transition-colors duration-200',
            'focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-1'
          )}
          aria-label="Ouvrir en plein écran"
          title="Ouvrir en plein écran"
        >
          <Maximize2 className="h-4 w-4" />
        </button>
      </div>

      {/* Content - PropertySearchChat */}
      <div className="flex-1 flex flex-col min-h-0 bg-white/50">
        <PropertySearchChat />
      </div>
    </div>
  );
};

export default ChatbotInline;

